module.exports = __webpack_public_path__ + "static/media/cal-medical-association-1.a8085a49.jpg";